import React from 'react'

import Button from '@amzn/meridian/button'
import Column from '@amzn/meridian/column'
import Divider from '@amzn/meridian/divider'
import Text from '@amzn/meridian/text'

class ErrorBoundary extends React.Component<any, any> {
    public state: any

    public static getDerivedStateFromError (error) {
        return { hasError: true, error }
    }

    constructor (props) {
        super(props)
        this.state = { hasError: false, error: null }
    }

    public componentDidCatch (error, errorInfo) {
        console.error(error, errorInfo)
    }

    public render () {
        if (this.state.hasError) {
            return (
                <Column spacing={'medium'} spacingInset="medium">
                    <Text type="h300" alignment={'center'} color={'error'}>
                        An error has occured.
                    </Text>
                    <Divider />
                    <Text type="h100" alignment="left"> {this.state.error.message } </Text>
                    <Text type="h100" alignment="left"> Please contact ATM team for assistance. </Text>
                    <Button type="primary" id="refresh-button"
                        onClick={() => location.assign(location.href)}> Reload page </Button>
                </Column>
            )
        }

        return this.props.children
    }
}

export default ErrorBoundary
